import { defineCustomElement } from '@tyler-components-web/core';
import { ColorPickerComponent } from './color-picker';
export * from './color-picker-adapter';
export * from './color-picker-constants';
export * from './color-picker-foundation';
export * from './color-picker';
export function defineColorPickerComponent() {
    defineCustomElement(ColorPickerComponent);
}
